import { AnalyticsEvent } from '@/core/analytics/events/AnalyticsEvent.ts'

enum DatagridActionsType {
  Search = 'Search',
  CategoryClick = 'Category Click',
  SpeciesFilter = 'Species Filter',
  RemoveFromPlan = 'Remove From Plan',
  AddToPlan = 'Add To Plan',
  ReplaceIntent = 'Replace Intent',
  ReplaceConfirmed = 'Replace Confirmed',
  UpdatePlanned = 'Update Planned',
  OpenTrend = 'Open Trend',
}

interface DatagridActionsEventProps extends Record<string, unknown> {
  type: DatagridActionsType
  value?: string
}

class DatagridActionsEvent extends AnalyticsEvent {
  constructor(props: DatagridActionsEventProps) {
    super('Datagrid Actions', props)
  }
}

export { DatagridActionsEvent, DatagridActionsType }
